// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Untermenü für lange App-Anleitungen */
.section-nav-wrap {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 1rem 3rem;
}

.section-nav-content {
  min-width: 0;
}

.section-nav {
  display: grid;
  gap: 0.5rem;
  align-content: start;
}

.section-nav .ui-eyebrow {
  margin: 0;
}

.section-nav ol {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
  margin: 0;
  padding: 0;
  list-style: none;
}

.section-nav a {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  padding: 0.3rem 0.6rem 0.3rem 0.4rem;
  border: 1px solid var(--border-primary);
  font-size: 0.88rem;
  line-height: 1.3;
  color: var(--text-primary);
}

.section-nav a:hover {
  border-color: var(--accent-primary);
}

.section-nav a .guide-icon {
  width: 20px;
  height: 20px;
}

@media (min-width: 1080px) {
  .section-nav-wrap.has-nav {
    grid-template-columns: 15rem minmax(0, 1fr);
  }

  .section-nav {
    position: sticky;
    top: calc(var(--header-height) + 80px);
    max-height: calc(100vh - var(--header-height) - 100px);
    overflow-y: auto;
  }

  .section-nav ol {
    display: grid;
    gap: 0;
    border-left: 1px solid var(--border-primary);
  }

  .section-nav a {
    position: relative;
    display: flex;
    padding: 0.4rem 0.4rem 0.4rem 0.8rem;
    border: 0;
    color: var(--text-secondary);
  }

  .section-nav a:hover {
    color: var(--text-primary);
  }

  .section-nav a.active {
    color: var(--text-primary);
    font-weight: 700;
  }

  .section-nav a.active::before {
    content: '';
    position: absolute;
    left: -1px;
    top: 0.35rem;
    bottom: 0.35rem;
    width: 3px;
    background: var(--accent-primary);
  }

  /* Mit Untermenü stehen die Abschnitte untereinander */
  .section-nav-wrap.has-nav .content-tab-grid {
    grid-template-columns: minmax(0, 1fr);
  }
}

.product-tab-section,
.custom-tab-section {
  scroll-margin-top: calc(var(--header-height) + 80px);
}

/* Icon vor Abschnittsüberschriften */
.section-heading-icon {
  display: inline-flex;
  align-items: center;
  gap: 0.6rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/product/SectionNav.css"],"names":[],"mappings":"AAAA,wCAAwC;AACxC;EACE,aAAa;EACb,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,oCAAoC;EACpC,uCAAuC;EACvC,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE;IACE,2CAA2C;EAC7C;;EAEA;IACE,gBAAgB;IAChB,sCAAsC;IACtC,sDAAsD;IACtD,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,MAAM;IACN,4CAA4C;EAC9C;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,oCAAoC;IACpC,SAAS;IACT,4BAA4B;EAC9B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;IAC1B,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,eAAe;IACf,UAAU;IACV,iCAAiC;EACnC;;EAEA,sDAAsD;EACtD;IACE,qCAAqC;EACvC;AACF;;AAEA;;EAEE,oDAAoD;AACtD;;AAEA,qCAAqC;AACrC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;AACb","sourcesContent":["/* Untermenü für lange App-Anleitungen */\n.section-nav-wrap {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n  gap: 1rem 3rem;\n}\n\n.section-nav-content {\n  min-width: 0;\n}\n\n.section-nav {\n  display: grid;\n  gap: 0.5rem;\n  align-content: start;\n}\n\n.section-nav .ui-eyebrow {\n  margin: 0;\n}\n\n.section-nav ol {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.4rem;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.section-nav a {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.45rem;\n  padding: 0.3rem 0.6rem 0.3rem 0.4rem;\n  border: 1px solid var(--border-primary);\n  font-size: 0.88rem;\n  line-height: 1.3;\n  color: var(--text-primary);\n}\n\n.section-nav a:hover {\n  border-color: var(--accent-primary);\n}\n\n.section-nav a .guide-icon {\n  width: 20px;\n  height: 20px;\n}\n\n@media (min-width: 1080px) {\n  .section-nav-wrap.has-nav {\n    grid-template-columns: 15rem minmax(0, 1fr);\n  }\n\n  .section-nav {\n    position: sticky;\n    top: calc(var(--header-height) + 80px);\n    max-height: calc(100vh - var(--header-height) - 100px);\n    overflow-y: auto;\n  }\n\n  .section-nav ol {\n    display: grid;\n    gap: 0;\n    border-left: 1px solid var(--border-primary);\n  }\n\n  .section-nav a {\n    position: relative;\n    display: flex;\n    padding: 0.4rem 0.4rem 0.4rem 0.8rem;\n    border: 0;\n    color: var(--text-secondary);\n  }\n\n  .section-nav a:hover {\n    color: var(--text-primary);\n  }\n\n  .section-nav a.active {\n    color: var(--text-primary);\n    font-weight: 700;\n  }\n\n  .section-nav a.active::before {\n    content: '';\n    position: absolute;\n    left: -1px;\n    top: 0.35rem;\n    bottom: 0.35rem;\n    width: 3px;\n    background: var(--accent-primary);\n  }\n\n  /* Mit Untermenü stehen die Abschnitte untereinander */\n  .section-nav-wrap.has-nav .content-tab-grid {\n    grid-template-columns: minmax(0, 1fr);\n  }\n}\n\n.product-tab-section,\n.custom-tab-section {\n  scroll-margin-top: calc(var(--header-height) + 80px);\n}\n\n/* Icon vor Abschnittsüberschriften */\n.section-heading-icon {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.6rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
